module.exports = __webpack_public_path__ + "img/img10.92b50314.png";